{
  "nl": {
    "employee": {
      "actions": {
        "accessProjects": "Toegang tot projecten beheren",
        "cancel": "Cancel",
        "changeProfilePicture": "Verander profielfoto",
        "download": "Download",
        "new": "Teamlid",
        "profilePictureFormat": "Moet vierkant formaat zijn, min. 300x300px",
        "save": "Opslaan",
        "searchEmployee": "Zoek Teamlid",
        "sendinvitation": "Maak aan en verstuur uitnodiging",
        "submit": "Opslaan",
        "undoChanges": "Annuleer"
      },
      "attributes": {
        "email_address": "Email",
        "email_notifications_interval": {
          "daily": "Een keer per dag (rond het middaguur)",
          "hourly": "Elk uur",
          "twice_daily": "Tweemaal per dag (ochtend/middag)",
          "weekly": "Een keer per week (maandagmiddag)"
        },
        "first_name": "Voornaam",
        "language": "Taal",
        "last_name": "Achternaam",
        "phone_landline": "Vast nummer",
        "phone_mobile": "Mobiel nummer",
        "profession": "Functie",
        "role": "Toegangsrechten",
        "signature_html": "Handtekening gesprekken",
        "status": "Status",
        "title": "Titel"
      },
      "billing": {
        "contact_us": "Contacteer ons",
        "contact_us_message": "Hallo, ik wil graag het pakket van {client_name} wijzigen.",
        "gigabytes": "{amount} GB",
        "in_use": "/ {total} in gebruik",
        "manage_members": "Leden beheren",
        "package": "Pakket",
        "package_help_mup": "Op zoek naar extra projecten of opslag, of wil je van plan veranderen?",
        "package_help_sup": "Op zoek naar extra projecten, plaatsen of opslag, of wil je van plan veranderen?",
        "plan_renamed": "We hebben nieuwe plannen ingevoerd, dus de naam die je hier ziet komt misschien niet overeen met je huidige abonnement. Contacteer ons voor meer info over de nieuwe plannen.",
        "projects": "Projecten",
        "projects_available": "Alle projecten in gebruik | 1 project beschikbaar | {count} projecten beschikbaar",
        "seats": "Plaatsen",
        "seats_active": "/ {total} actief",
        "seats_package": "Geen plaatsen in je pakket | 1 plaats in je pakket | {count} plaatsen in je pakket",
        "seats_paying": "+ 1 extra betalende plaats | + {count} extra betalende plaatsen",
        "storage": "Opslag",
        "storage_available": "{amount} GB beschikbaar",
        "storage_total": "/ {amount} GB",
        "units": "Units",
        "units_available": "Alle units in gebruik | 1 unit beschikbaar | {count} units beschikbaar"
      },
      "integrations": {
        "hide_details": "Verberg details",
        "last_synced_at": "Laatst gesynchroniseerd op: {time}",
        "show_details": "Toon details"
      },
      "labels": {
        "all_projects": "Alle projecten",
        "confirmPasswordReset": "Een email is verzonden met een link voor een wachtwoordwijziging, gelieve je inbox te controleren. Contacteer ons indien je problemen ondervindt.",
        "disabled": {
          "access": "We verlenen alle medewerkers toegang tot het platform vanaf het moment dat de laatste achterstallige factuur is betaald.",
          "contact": "Neem contact op",
          "overdue": "We hebben gemerkt dat jouw laatste factuur nog niet betaald is. We hebben de toegang voor alle medewerkers op dit platform ingetrokken. Partners en klanten hebben nog steeds toegang tot hun gegevens.",
          "title": "Jouw account is uitgeschakeld!"
        },
        "display": "Weergave",
        "filters": "Filters",
        "generalNotifications": "Krijg notificaties voor",
        "has_access_to": "Heeft toegang tot",
        "information": "Profielinformatie",
        "informationNotificationsEmail": "Ontvang een overzicht via e-mail, inclusief alleen meldingen die je nog niet hebt gezien op het platform.",
        "informationNotificationsPlatform": "Ontvang alle notificaties in jouw persoonlijk overzicht die zich rechtsboven van je scherm bevindt",
        "informationNotificationsTitle": "Bepaal welke notificaties je wil ontvangen en via welk kanaal",
        "its_you!": "Dit ben jij!",
        "maintainerAccess": "Toegang per project.",
        "name": "Naam",
        "onPlatform": "Op Platform",
        "ownerAccess": "Toegang tot alle projecten en inhoud, plus facturatie en teambeheer.",
        "password": "Wachtwoord",
        "permissions": "Toegangsrechten voor",
        "permissionsOwnerOnly": "Als projectbeheerder kan je deze actie niet uitvoeren. Vraag een {client_name} teamlid met rol Eigenaar om dit voor jou te doen.",
        "projectMaintains": "{first_name} heeft toegang tot de volgende projecten:",
        "projectMaintainsAdd": "Om toegang te verlenen, selecteer een project en voeg {first_name} toe als Beheerder bij de Informatie pagina",
        "projectMaintainsNone": "heeft momenteel geen toegang tot projecten.",
        "projectNotifications": "Voor project",
        "search_by_name_or_email": "Zoeken op naam of e-mail",
        "show_signature": "Toon handtekening",
        "signature_active": "Handtekening actief",
        "signature_info": "Deze handtekening wordt toegevoegd aan antwoorden die naar klanten en partners worden verzonden.",
        "sorting": "Sorteren",
        "viaEmail": "Via Email"
      },
      "modals": {
        "maintainers_access": {
          "accessible": "Toegankelijk",
          "description": "Wijzigingen worden automatisch opgeslagen",
          "not_accessible": "Niet toegankelijk",
          "title": "Projecttoegang bijwerken voor {first_name} {last_name}"
        }
      },
      "roles": {
        "maintainer": "Beheerder",
        "owner": "Eigenaar"
      },
      "team": {
        "actions": {
          "activate": "Activeren",
          "cancel_invitation": "Uitnodiging annuleren",
          "deactivate": "Deactiveren",
          "invite": "Uitnodigen",
          "make_maintainer": "Maak beheerder",
          "make_owner": "Maak eigenaar",
          "remove": "Verwijderen uit team"
        },
        "dialogs": {
          "activate_body": "{name} krijgt opnieuw volledige toegang tot het platform.",
          "activate_body_pending": "{name} gaat terug naar In afwachting en wordt actief bij het aanmelden met de uitnodiging.",
          "activate_body_seat": "{name} krijgt opnieuw volledige toegang tot het platform. Dit gebruikt één plaats.",
          "activate_confirm": "Activeren",
          "activate_title": "{name} activeren?",
          "cancel_invitation_body": "{name} kan niet meer deelnemen met de ontvangen uitnodiging.",
          "cancel_invitation_confirm": "Uitnodiging annuleren",
          "cancel_invitation_title": "Uitnodiging annuleren?",
          "contact_us": "Contacteer ons",
          "contact_us_message": "Hallo, ik wil graag extra plaatsen voor {client_name}.",
          "deactivate_body": "{name} behoudt het account maar verliest de toegang tot het platform.",
          "deactivate_body_seat": "{name} behoudt het account maar verliest de toegang tot het platform. Dit maakt één plaats vrij.",
          "deactivate_confirm": "Deactiveren",
          "deactivate_title": "{name} deactiveren?",
          "demote_body": "{name} verliest de toegang tot alle projecten tot je die toekent, en kan facturatie en het team niet meer beheren.",
          "demote_confirm": "Maak beheerder",
          "demote_title": "{name} beheerder maken?",
          "owner_wall_banner": "Je organisatie moet altijd minstens één actieve eigenaar hebben.",
          "owner_wall_body_deactivate": "Heractiveer of promoveer een andere eigenaar voor je {name} deactiveert.",
          "owner_wall_body_demote": "Heractiveer of promoveer een andere eigenaar voor je de rol van {name} wijzigt.",
          "owner_wall_body_remove": "Heractiveer of promoveer een andere eigenaar voor je {name} verwijdert.",
          "owner_wall_title": "Actie geblokkeerd",
          "promote_body": "{name} krijgt toegang tot alle projecten en kan facturatie en het team beheren.",
          "promote_confirm": "Maak eigenaar",
          "promote_title": "{name} eigenaar maken?",
          "remove_body": "{name} verliest de toegang en verdwijnt uit de ledenlijst. Je kan dit niet ongedaan maken, maar je kan later opnieuw uitnodigen.",
          "remove_body_seat": "{name} verliest de toegang en verdwijnt uit de ledenlijst. Je kan dit niet ongedaan maken, maar je kan later opnieuw uitnodigen. Dit maakt één plaats vrij.",
          "remove_confirm": "Verwijderen",
          "remove_title": "{name} uit het team verwijderen?",
          "seats_full_banner": "Je enige plaats is in gebruik. | Alle {total} plaatsen zijn in gebruik.",
          "seats_full_body": "Deactiveer een actief lid om een plaats vrij te maken, of neem contact met ons op voor extra plaatsen.",
          "seats_full_invite_body": "Je hebt een vrije plaats nodig om iemand uit te nodigen. Deactiveer een actief lid, of neem contact met ons op voor extra plaatsen.",
          "seats_full_invite_title": "Je plaatsen zijn op",
          "seats_full_title": "Geen plaatsen vrij"
        },
        "invite_incomplete": "Vul voornaam, achternaam en e-mail in om de uitnodiging te versturen.",
        "invite_note": "Ze worden actief zodra ze een account aanmaken en inloggen.",
        "invite_note_seats": "Zodra ze een account aanmaken en inloggen, worden ze actief en gebruiken ze je laatste vrije plaats. | Zodra ze een account aanmaken en inloggen, worden ze actief en gebruiken ze één van je {count} vrije plaatsen.",
        "invite_sent": "Uitnodiging verstuurd",
        "invited_at": "Uitgenodigd: {when}",
        "last_active": "Laatst actief",
        "manage_in_billing": "Beheren in Facturatie",
        "resend_wait": "Je kan de uitnodiging 15 minuten na de vorige opnieuw versturen.",
        "role": "Rol",
        "seat_states": "Statussen",
        "seat_states_help": {
          "active": "Volledige toegang, gebruikt één plaats. Eigenaars en beheerders.",
          "inactive": "Account bestaat, geen toegang tot het platform. Maakt de plaats vrij.",
          "pending": "Uitgenodigd, nog geen account. Gebruikt geen plaats."
        },
        "seat_usage": "Gebruik van plaatsen",
        "seats_available": "Geen plaatsen vrij — deactiveer een lid of neem contact met ons op | 1 plaats vrij | {count} plaatsen vrij",
        "seats_rule": "Enkel een eigenaar kan een lid activeren, en enkel zolang er een plaats vrij is.",
        "seats_total": "/ {total} actieve plaats | / {total} actieve plaatsen",
        "statuses": {
          "active": "Actief",
          "inactive": "Inactief",
          "pending": "In afwachting"
        }
      },
      "toasts": {
        "create": "Teamlid is aangemaakt",
        "update": "Teamlid is gewijzigd"
      },
      "validation": {
        "emailTaken": "Emailadres is al in gebruik",
        "mustBeEmailAddress": "Geldig emailadres vereist",
        "needFirstName": "Voornaam vereist",
        "needLastName": "Achternaam vereist",
        "requireEmailAddress": "Email vereist",
        "role": "Selecteer toegangsrechten"
      }
    }
  }
}
